import reducer from './tutorial';
import { actionCreators, TutorialActionType } from './tutorial.actionCreators';
import * as actionTypes from './tutorial.actionTypes';

export * from './tutorial'; // expose all types
export type ActionType = TutorialActionType;
export { actionTypes, actionCreators };
export default reducer;
